import React from 'react'
import {
  VocLarge,
  TwitterSolid,
  Facebook,
  InstagramSquare,
  Youtube,
  Tiktok,
  Bluesky,
  Podcasts
  // @ts-ignore
} from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import Domain from 'enums/Domain'
import StreamSymbol from 'enums/StreamSymbol'
import { useContextMediaDetail } from './context'

interface DomainIconProps {
  domain?: string
  dataStream?: string
}

const DomainIcon = ({
  domain: domainFromProp,
  dataStream: dataStreamFromProp
}: DomainIconProps) => {
  const displayTheme = useDisplayTheme()
  const { domain: domainFromContext, dataStream: dataStreamFromContext } = useContextMediaDetail()

  const domain = domainFromProp || domainFromContext
  const dataStream = dataStreamFromProp || dataStreamFromContext

  if (dataStream === StreamSymbol.VOC) {
    return <VocLarge mode={displayTheme} />
  }
  if (dataStream === StreamSymbol.PODCAST) {
    return <Podcasts mode={displayTheme} />
  }
  if (domain === Domain.TWITTER) {
    return <TwitterSolid mode={displayTheme} />
  }
  if (domain === Domain.FACEBOOK) {
    return <Facebook mode={displayTheme} />
  }
  if (domain === Domain.INSTAGRAM) {
    return <InstagramSquare mode={displayTheme} />
  }
  if (domain === Domain.YOUTUBE) {
    return <Youtube mode={displayTheme} />
  }
  if (domain === Domain.TIKTOK) {
    return <Tiktok mode={displayTheme} />
  }
  if (domain === Domain.BLUESKY) {
    return <Bluesky mode={displayTheme} />
  }
  return null
}

export default DomainIcon
